import React from "react";
import image from "../assets/images/pipe.svg";
import { Link } from "react-router-dom";
import { BsArrowUpRightSquare } from "react-icons/bs";
import ReadMoreContent from "../components/ReadMoreContent";

const ResultSection = (props) => {
  const EXCELLENT_SUITABILITY = "A";
  const GOOD_SUITABILITY = "B";
  const FAIR_SUITABILITY = "C";
  const DO_NOT_USE_SUITABILITY = "X";
  function checkSuitability(props) {
    switch (props) {
      case EXCELLENT_SUITABILITY:
        return "Excellent";
      case GOOD_SUITABILITY:
        return "Good";
      case FAIR_SUITABILITY:
        return "Fair";
      case DO_NOT_USE_SUITABILITY:
        return "Do not use";
      default:
        return "No Data";
    }
  }

  return (
    <>
      <div className="col-lg-7     align-items-stretch  order-1 order-lg-2">
        <p>SUITABLE RANKED HOSES* Output</p>
        {props.items.resultingHose.length === 0 && (
          <h6 className="hose-list__fallback">No suitable hoses found for your inputs. Please revise inputs.</h6>
        )}
        {props.items.resultingHose.length > 0 && (
          <div className="table-responsive ">
            <table className="table ">
              <thead>
                <tr className="table-row-header">
                  <th className="col-header-web-link">Pic / Link</th>
                  <th className="col-header-hose-name">Hose Name / Link</th>
                  <th className="col-header-press-temp-radious">Max Press. (psi)</th>
                  <th className="col-header-press-temp-radious">Max Temp. (°F)</th>
                  <th className="col-header-press-temp-radious">Bend Radius (in)</th>
                  <th className="col-header-discription">Description</th>
                </tr>
              </thead>
              <tbody>
                {props.items.resultingHose.map((hose) => (
                  <tr className="table-row" key={hose.rank}>
                    <td className="col-data-web-link">
                      <Link target="_blank" to={hose.web_url}>
                        <img src={tryRequire(hose.hose_name.replace(" / ", " ").replace("/", "") + ".jpg")} alt="" aria-hidden="true" />
                      </Link>
                    </td>
                    <td className="col-data-hose-name">
                      {" "}
                      <Link target="_blank" to={hose.web_url}>
                        {hose.hose_name} <BsArrowUpRightSquare />
                      </Link>
                    </td>
                    <td className="col-data-press-temp-radious">{hose.pressure}</td>
                    <td className="col-data-press-temp-radious"> {hose.temperature}</td>
                    <td className="col-data-press-temp-radious"> {hose.bend_radius}</td>
                    <td className="col-data-discription">
                      <ReadMoreContent content={hose.hose_desc} maxLength={35} style={{ color: "black" }} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <br />
        <div className="note-div">
          <h6>Note that most hoses can be purchased on our website. Click the picture above or the Hose Name to link to details.</h6>
        </div>
        <div className="heading7">
          <span>
            *These hoses are possibilities only. It is recommended that the hose user test the hose under all operating conditions to insure
            safe performance.
          </span>
        </div>
        {props.items.suitability.length === 0 && <div></div>}
        {props.items.suitability[0] && (
          <div id="fms-div">
            <h1>FITTING MATERIAL SUITABILITY</h1>
            <h5>Check these fitting materials for media compatibility.</h5>

            <div className="suitability-div">
              <div className="grid-item3">
                <span>Media Group</span>
                <p>Populated From Media</p>
              </div>
              <div className="grid-item4">
                <span>GALV CS</span>
                <p>{checkSuitability(props.items.suitability[0]["GALV CS"])}</p>
              </div>
              <div className="grid-item4">
                <span>316 SS</span>
                <p>{checkSuitability(props.items.suitability[0]["SS 316"])}</p>
              </div>
              <div className="grid-item4">
                <span>304 SS</span>
                <p>{checkSuitability(props.items.suitability[0]["SS 304"])}</p>
              </div>
              <div className="grid-item4">
                <span>ALUM</span>
                <p>{checkSuitability(props.items.suitability[0]["Aluminum"])}</p>
              </div>
              <div className="grid-item4">
                <span>BRASS</span>
                <p>{checkSuitability(props.items.suitability[0]["Brass"])}</p>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ResultSection;

const tryRequire = (path) => {
  try {
    const image_name = require("../assets/images/36px_" + path);
    return image_name;
  } catch (err) {
    console.log(err);
    return image;
  }
};
export const image_name = require("../assets/images/36px_FD2 HIGH TEMP SILICONE EXHAUST HOSE.jpg");
